import { Trans } from "@lingui/react/macro";

/** Informational only; connecting a service needs no separate data-sharing approval.
 * Лише інформація: підключення сервісу не потребує окремого погодження передачі даних. */
export function AiDataSharingSettings() {
  return (
    <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
      <Trans>
        Connected AI services receive the voice, messages and context needed to process your
        requests.
      </Trans>
    </p>
  );
}
